import React from "react";

export default function ProjectCard({ project }) {
  const { title, description, category, techStack, github, live, apkLink, image, featured } = project;

  return (
    <div className="card" style={{ display: "flex", flexDirection: "column", gap: 14, position: "relative" }}>
      {featured && (
        <span style={{
          position: "absolute", top: 14, right: 14,
          background: "var(--accent)", color: "#000",
          fontSize: 10, fontWeight: 700, padding: "3px 8px",
          borderRadius: 4, letterSpacing: "0.05em",
        }}>FEATURED</span>
      )}

      {/* Image */}
      {image ? (
        <img src={image} alt={title} style={{ width: "100%", height: 160, objectFit: "cover", borderRadius: 8 }} />
      ) : (
        <div style={{
          width: "100%", height: 160, borderRadius: 8,
          background: "linear-gradient(135deg, #111118, #1a1a2e)",
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: 36,
        }}>
          {category === "Mobile App" ? "📱" : category === "IoT" ? "🔌" : "🌐"}
        </div>
      )}

      {/* Category tag */}
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
        <span className="tag">{category}</span>
      </div>

      {/* Title + description */}
      <h3 style={{ fontSize: 18, fontWeight: 700 }}>{title}</h3>
      <p style={{ color: "var(--muted)", fontSize: 14, flex: 1, lineHeight: 1.6 }}>
        {description.length > 120 ? description.slice(0, 120) + "…" : description}
      </p>

      {/* Tech stack */}
      {techStack?.length > 0 && (
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
          {techStack.map((t) => (
            <span key={t} style={{ fontSize: 11, background: "rgba(124,58,237,0.15)", color: "#a78bfa", border: "1px solid rgba(124,58,237,0.2)", borderRadius: 4, padding: "2px 8px" }}>
              {t}
            </span>
          ))}
        </div>
      )}

      {/* Action links */}
      <div style={{ display: "flex", gap: 8, marginTop: 4, flexWrap: "wrap" }}>
        {github && (
          <a href={github} target="_blank" rel="noreferrer" className="btn btn-outline" style={{ fontSize: 13, padding: "7px 14px" }}>
            GitHub
          </a>
        )}
        {live && (
          <a href={live} target="_blank" rel="noreferrer" className="btn btn-primary" style={{ fontSize: 13, padding: "7px 14px" }}>
            Live Demo
          </a>
        )}
        {apkLink && (
          <a href={apkLink} target="_blank" rel="noreferrer" className="btn" style={{ fontSize: 13, padding: "7px 14px", background: "var(--success)", color: "#000", fontWeight: 600 }}>
            ⬇ Download APK
          </a>
        )}
      </div>
    </div>
  );
}
